import { mapActions } from 'vuex';

export default {
	data() {
		return {
			variation: '',
			status: 'No unsaved changes'
		};
	},
	methods: {
		...mapActions('form', {
			deactivateActivateFormAction: 'deactivateActivateForm'
		}),
		changeActiveDeactivate(val) {
			if (this.editionMode) {
				this.deactivateActivateForm(val);
			}
		},
		async deactivateActivateForm(val) {
			let isActive = this.form.active;
			let action = val ? 'activate' : 'deactivate';
			await this.deactivateActivateFormAction({
				id: this.form.id,
				action: action
			})
				.then(isSuccessful => {
					if (isSuccessful) {
						this.form.active = !isActive;
						this.form.minutesAgo = 0;
						this.variation = 'success';
						this.status = `Form successfully ${action}d`;
					} else {
						this.variation = 'error';
						this.status = `Form unsuccessfully ${action}d`;
						this.form.active = isActive;
					}
				})
				.catch();
		}
	}
};
